import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
export var ITextResourceConfigurationService = createDecorator('textResourceConfigurationService');
export var ITextResourcePropertiesService = createDecorator('textResourcePropertiesService');



//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/editor/common/services/resourceConfiguration.js
// module id = 278
// module chunks = 58